import { IconProps } from './iconTypes';

export const ArrowDropDown = ({ color, ...props }: IconProps): JSX.Element => (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
        <path d="M7 10l5 5 5-5z" fill={color} />
        <path d="M0 0h24v24H0z" fill="none" />
    </svg>
);
